var MuiOutlinedInput = {
    /* put your new default props here */
    notched: true,
};
export default MuiOutlinedInput;
//# sourceMappingURL=MuiOutlinedInput.js.map